import React, { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { initialLotValues, LotFormattedData, lotSchema } from '../../schemas';
import { Lo, LoInput, type VatTu } from '@/types/schemas';
import { FormMode } from '@/types/form';
import LotForm from './LotForm';

type LotDialogInitialData = Lo & {
  ma_vt_data?: VatTu | null;
};

interface LotDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: LotDialogInitialData;
  onClose: () => void;
  onSubmit: (data: LoInput) => void | Promise<void>;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const LotDialog: React.FC<LotDialogProps> = ({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}) => {
  const [vatTu, setVatTu] = useState<VatTu | null>(initialData?.ma_vt_data || null);

  const handleSubmit = async (data: LotFormattedData) => {
    const lotData: LoInput = {
      ...data,
      ma_vt: vatTu?.uuid ?? initialData?.ma_vt ?? null
    };

    await onSubmit(lotData);
  };

  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem chi tiết';

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={title}
        maxWidth='lg'
        disableBackdropClose={false}
        disableEscapeKeyDown={false}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={lotSchema}
          onSubmit={handleSubmit}
          initialData={initialData || initialLotValues}
          className='w-full md:min-w-[500px] lg:min-w-[900px]'
          headerFields={<LotForm mode={mode} vatTu={vatTu} setVatTu={setVatTu} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default LotDialog;
